import { ApiResponse } from '@shared/models/api.model';
import axiosInstance from '../axios-instance';
import { LiveTvModel } from '@modules/entertainment/models/live-tv.models';
import { CategoriesModel } from '@modules/entertainment/models/entertainment.models';

export const getLiveTv = async (
  params?: any
): Promise<ApiResponse<LiveTvModel>> => {
  const response = await axiosInstance.get('/media/channels/getter', {
    params
  });
  return response.data;
};

export const createChannel = async (
  body?: any
): Promise<ApiResponse<LiveTvModel>> => {
  return await axiosInstance.post(`/media/channels`, body);
};

export const editChannelRow = async (
  body: any,
  id: string
): Promise<ApiResponse<LiveTvModel>> => {
  return await axiosInstance.put(`/media/channels/${id}`, body);
};

export const deleteChannel = async (id: string): Promise<void> => {
  return await axiosInstance.delete(`/media/channels/${id}`);
};

export const deleteChannelsMany = async (id: string[]): Promise<void> => {
  const data = { ids: id };
  await axiosInstance.delete(`/media/channels/many`, { data });
};

export const getLiveTvCategories = async (): Promise<any[]> => {
  const response = await axiosInstance.get('/media/categories');
  return response.data;
};

export const createLiveTvCategory = async (
  body?: any
): Promise<CategoriesModel> => {
  return await axiosInstance.post(`/media/categories`, body);
};

export const editCategory = async (
  body: any,
  id: any
): Promise<CategoriesModel> => {
  return await axiosInstance.put(`/media/categories/${id}`, body);
};

export const deleteCategory = async (id: string): Promise<void> => {
  return await axiosInstance.delete(`/media/categories/${id}`);
};

export const importInternetProvider = async (body?: {
  name: string;
  apiKey: string;
}): Promise<any> => {
  return await axiosInstance.post(`/media/integrations/provider`, body);
};

export const importM3u = async (body?: {
  playlistUrl: string;
}): Promise<any> => {
  return await axiosInstance.post(`/media/integrations/m3u/import`, body);
};

export const enableChannelsMany = async (ids: string[]): Promise<void> => {
  await axiosInstance.patch(`/media/channels/enable/many`, { ids });
};

export const disableChannelsMany = async (ids: string[]): Promise<void> => {
  await axiosInstance.patch(`/media/channels/disable/many`, { ids });
};

export const enableAllChannels = async (): Promise<void> => {
  await axiosInstance.patch(`/media/channels/enable/all`);
};

export const disableAllChannels = async (): Promise<void> => {
  await axiosInstance.patch(`/media/channels/disable/all`);
};
